export default __webpack_public_path__ + "static/media/1.6b6646f9.png";